<template>
    <div class="orders-history">
      <OrdersHistorySkeleton :is-loading="!isOrdersDataReady">
        <div v-if="!isEmpty" class="orders-history__wrapper">
          <SmartLink route="history" class="orders-history__title-link flex items-center justify-between">
            <h2 class="orders-history__title flex align-center justify-between">Історія замовлень <ThickArrowIcon direction="right" /></h2>
          </SmartLink>
          <p class="orders-history__subtitle">Цього місяця ви здійснили {{ this.getExpirationText(getCurrentMonthValue('count'), getSaleForms) }}.</p>
          <OrdersHistoryList :orders="getOrdersHistoryList" />
        </div>
        <EmptyBlock v-else :title="getEmptyMessage.title" :description="getEmptyMessage.description" height="400px" />
      </OrdersHistorySkeleton>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import OrdersHistoryList from '../orders-history-list';
import OrdersHistorySkeleton from '../orders-history-skeleton';
import { saleForms } from '@/shared/config/expiration-forms';
import { expirationText } from '@/shared/lib/string';
import { EmptyBlock } from '@/shared/ui/empty-block';
import { ThickArrowIcon } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  created() {
    this.fetchOrdersList();
  },
  mixins: [ expirationText ],
  components: { OrdersHistoryList, ThickArrowIcon, OrdersHistorySkeleton, EmptyBlock, SmartLink },
  computed: {
    ...mapGetters('ordersHistoryModule', [
      'isOrdersDataReady', 'getOrdersHistoryList', 'isEmpty', 'getEmptyMessage',
    ]),
    ...mapGetters('statisticSummaryModule', ['getCurrentMonthValue']),
    getSaleForms() {
      return saleForms.forms;
    },
  },
  methods: {
    ...mapActions('ordersHistoryModule', ['fetchOrdersList']),
  }
};
</script>

<style lang="scss" scoped>
.orders-history {
  border: 1px solid #E4E4E7;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;
  margin: 0 16px 16px 0;

  @media (min-width: 1050px) {
    min-height: 464px;
  }

  @media (max-width: 1050px) {
    margin: 0 0 16px;
  }

  &__title {
    font-family: inherit;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 6px;
  }

  &__subtitle {
    font-family: inherit;
    font-size: 14px;
    font-weight: 400;
    color: #71717A;
    margin-bottom: 24px;
  }

  &__title-link {
    width: 100%;
  }
}
</style>
